import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { SalesOrderService, ComboService } from "../../../services/index";

@Component({
  selector: "addEdit-SalesReturn-Bundle",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./addEditAgentpayment.html",
})
export class addEditAgentpayment {
  modeList = ["NEFT", "CHEQUE", "DD", "CASH"];
  mode: string;
  saveEvent: any;
  isLoading: boolean = false;
  partyList = [];
  teamList = ["PRIME", "PREMIUM"];
  list = [];
  isLoadMask: Promise<any>;
  agentList = [];
  pay_check: boolean = false;
  loadingIndicator: boolean = true;
  paymentData: any = {
    ref_no: 0,
    date: new Date(),
    team: "",
    agent: "",
    pay_mode: "",
    bank_name: "",
    bank_ref_no: "",
    pend_amount: 0,
    payment: 0,
    narration: "",
  };

  @Input() _params: any;
  @Input() active = false;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);

    if (this.mode == "View") {
      this.paymentData = designdata;
      // this.loaddesignList(this.paymentData.creditid);
      this.paymentData.agent = designdata.agent_name;
      this.paymentData.pay_mode = designdata.mode;
      this.getagentPaymentEntryList(designdata['pay_id']);
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private salesservice: SalesOrderService,
    private comboservice: ComboService
  ) {}
  ngOnInit() {
    if (this.mode == "Add") {
      this.getPartyList();
      this.getAgentList();
      this.getPaymantAuto();
    }
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#ret_date").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 100);
    }
  }
  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }

  // selectParty(party_name) {
  //   let that = this;
  //   that.partyList.forEach(function (key) {
  //     if (key.name == party_name) {
  //       that.paymentData.party_id = key.genLedid;
  //       that.paymentData.agentid = key.agent_id;
  //       that.paymentData.transport = key.transport;

  //       return false;
  //     }
  //   });
  //   // this.paymentData.party_id = $event.genLedid;
  //   // this.paymentData.agentid = $event.agent_id;
  // }
  // loaddesignList(id) {
  //   let params = {
  //     creditid: id,
  //     order_type: "Order Form",
  //     page: 1,
  //     start: 0,
  //     limit: 100,
  //   };
  //   this.salesservice.getSiRtnEntryGridShirtSizeDet(params).then((res: any) => {
  //     this.paymentData = res;

  //   });
  // }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }
  onSelectbrand(brand) {
    this.paymentData.pay_mode = brand;

    if (this.paymentData.pay_mode == "CASH") {
      this.pay_check = true;
    } else {
      this.pay_check = false;
    }
  }
  getPaymantAuto() {
    if (this.mode == "Add") {
      this.salesservice.getPaymantAuto({}).then((res: any) => {
        this.paymentData.ref_no = res;
        // this.getWoAuto();
      });
    }
  }

  getAgentList() {
    let that = this;
    that.salesservice.getAgentList({}).then((res: any) => {
      this.list = res;
    });
  }

  onSelectTeam(type) {
    let data = this.list;
    this.agentList = data.filter((el) => el.incharger == type);
    // console.log(data,"Check Call", this.agentList)
  }

  onSelectagent(type) {
    let data = this.list;
    let obj = data.find((o) => o.name === type);

    this.paymentData.agent_id = obj.genLedid;
    this.paymentData.pend_amount = 0;
    // let params = {
    //   agent_id : this.paymentData.agent_id
    // }

    //   this.salesservice.getAgentPendingCommission(params).then((res: any) => {
    //     if(res){
    //       this.paymentData.pend_amount = Number(res);
    //     }else{
    //       this.paymentData.pend_amount = 0;
    //     }
        
    //   });
    
    //  console.log(this.masterData);
  }

  oncheckemptyrow() {
    let design = this.paymentData;
    let empty_check = false;
    // for(var key in design) {
    //   if(!design[key]) {
    //     swal("PLEASE ENTER ALL THE DETAILS!");
    //     empty_check = true;
    //     console.log(design[key])
    //   }

    // }
    if (!empty_check) {
      this.onSaveOrder();
    }
  }

  onSaveOrder() {
    if(this.paymentData.payment > 0){
let params: any = Object.assign({}, this.paymentData);
    params["date"] = this.datePipe.transform(
      this.paymentData.date,
      "yyyy-MM-dd"
    );
    // params["ret_date"] = this.datePipe.transform(
    //   this.paymentData.ret_date,
    //   "yyyy-MM-dd"
    // );
    let that = this;
    that.isLoading = true;
    if (that.mode == "Add") {
      swal({
        title: "Are you sure to save this Sales Person Entry Details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.salesservice
          .addPaymentEntry(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              //    that.printdata(res.printData);
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
    }else{
      swal("Payment cannot be 0");
      return;
    }
    
  }
  getagentPaymentEntryList(pay_id): void {
    let params ={
       page: 1,
       start: 0,
       limit: 100,
       pay_id
    };
   let that = this;
   //this.store.dispatch(new commonActions.LoadAllParty(params));
   this.isLoadMask = this.salesservice
     .getagentPaymentEntryList(params)
     .then(function(res: any) {
       that.loadingIndicator = false;
       that.paymentData = res.data[0];
    });
 }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/agentPayment/addEditAgentpayment.ts